// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stars {
  height: 15px;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/product/product-compact-rating/product-compact-rating-points/product-compact-rating-points.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qBAAA;AACF","sourcesContent":[".stars {\n  height: 15px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
